import { request } from '../request'

export function submitApproval(data) {
  return request({
    url: '/award/wjpayaccountrecord/awardOrderAuditStart',
    method: 'post',
    data
  })
}

export function getAuditInfo(id) {
  return request({
    url: '/award/wjpayaccountrecord/awardOrderAuditInfo',
    method: 'get',
    params: {
      id
    }
  })
}

export function auditNext(data) {
  return request({
    url: '/award/wjpayaccountrecord/awardOrderAuditNext',
    method: 'post',
    data
  })
}
